import { Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from "@mui/material";

export function CheckBoxGroup({ options }) {
    // const [checkedItems, setCheckedItems] = useState(options.reduce((acc, cur) => {
    //     if (!acc[cur]) {
    //         acc[cur] = false;
    //     }
    //     return acc;
    // }, {}));

    const handleCheckboxChange = (event,index) => {
       options[index].isChecked = event.target.checked;
    };

    return (
        <FormControl component="fieldset">
            <FormGroup>
                {options.map((option,i) =>
                    <FormControlLabel
                        sx={{ fontFamily: "Figtree", fontSize: "14px" }}
                        control={<Checkbox size="small" sx={{ fontFamily: "Figtree", fontSize: "14px","&.Mui-checked": {
      color: process.env.REACT_APP_ENTERPRISE_COLOUR, 
    },
 }} checked={option.isChecked} onChange={(e)=>{
                            handleCheckboxChange(e,i)
                        }} name={option.title} />}
                        label={<Typography sx={{ fontFamily: "Figtree", color: "#555555", fontSize: "14px" }}>{option.title}</Typography>}
                    />
                )}
            </FormGroup>
        </FormControl>
    );
}